/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getOrderingProfile} from '../api'

 export const useQueryGetOrderingProfile = createReactQueryHook('getOrderingProfile', getOrderingProfile)
